import {defineMessages} from 'react-intl';

export default defineMessages({
	inTheMoodFor: {
		id: 'plp.refinements.inTheMoodFor',
		defaultMessage:'In the mood for',
	},
});
